// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__CI93M","lastUpdated":"PrivacyPolicy_lastUpdated__1BBKg"};